<template>
  <v-simple-table dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Nº</th>
          <th class="text-left">
            Descontos ({{ matriculado ? "matriculado" : "não matriculado" }} no ano anterior)
          </th>
          <th class="text-left">Vencimento</th>
          <th class="text-left">Valor</th>
          <th class="text-left">Valor Pago</th>
          <th class="text-left">Valor Em Aberto</th>
          <th class="text-left">Desconto</th>
          <th class="text-left">Situação</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ parcela.numero }}</td>
          <td>
            <div v-for="faixa in faixas" :key="faixa.id">
              {{ formatarData(faixa.data) }} -
              {{
                (matriculado ? faixa.desconto_matriculado : faixa.desconto_nao_matriculado)
                  | currency
              }}
            </div>
            <span v-if="faixas.length === 0">Sem desconto</span>
          </td>
          <td>{{ formatarData(parcela.referencia) }}</td>
          <td>{{ parcela.valor | currency }}</td>
          <td>{{ parcela.valorpago | currency }}</td>
          <td>
            <v-chip color="green" class="white--text">{{ valorEmAberto | currency }}</v-chip>
          </td>
          <td>{{ parcela.desconto | currency }}</td>
          <td><e-situacao-parcela :parcela="parcela" /></td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import Parcela from "@/Models/Parcela";
import { formatarData } from "./helpers";

/**
 * A parcela da pré-matrícula nas colunas da tela de baixa de mensalidade. As faixas de desconto
 * são as do período (não da matrícula), mostrando só o valor da situação do aluno no ano
 * anterior, que vem da API; o vencimento é a data de fechamento do período (`referencia`).
 */
export default {
  name: "ETabelaParcelaPreMatricula",
  props: {
    parcela: { type: Parcela, required: true },
    faixas: { type: Array, default: () => [] },
    valorEmAberto: { type: Number, default: 0 },
    // Aluno com matrícula no ano letivo anterior: escolhe a coluna de desconto.
    matriculado: { type: Boolean, default: false },
  },
  methods: { formatarData },
};
</script>
